import { Injectable } from '@angular/core';
import { Common } from '@shared/services/common/models';
import { StoreBase } from '@stores/abstract';

@Injectable({ providedIn: 'root' })
export class CommonStore extends StoreBase<Common> {
  override storeName = 'CommonStore';
}
